/* unplugin-vue-components disabled */import script from "./Excel.vue?vue&type=script&setup=true&lang=ts"
export * from "./Excel.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__